const levyAttachment = "//donline.alliedworldgroup.com.hk/file/IALevy.pdf";

const ImportantNoticesTerms = () => (
  <ol>
    <li>
      For the full terms, conditions and exclusions please read the Policy Wording, a copy of which is available from your insurance representative
      for this scheme.
      <br />
      請參閱保單條文了解該保單的利益及主要不保事項簡介。閣下可從閣下的保險代理人索取該保單條款。
    </li>
    <li>
      This Professional Indemnity Insurance Policy is issued on a claims made and notified basis:
      <br />
      此份專業責任保單只適用於保單期內首次提出並已呈報的索償:
      <ol type="a">
        <li>
          This means that the policy responds to claims first made against you during the policy period and notified to the insurer during that policy
          period.
          <br />
          保單只適用於保單期內首次提出並已呈報予保險公司的索償。
        </li>
        <li>
          The policy does not respond to any claim arising out of facts or circumstances of which you were aware at any time prior to the policy
          period which would have put a reasonable person in your position on notice that a claim may be made against you. (Some cover may be
          available under the Continuous Cover extension for innocent non-disclosure of facts and circumstances – but only if you are continuously
          insured under a professional indemnity policy issued by Allied World Assurance Company, Ltd (Hong Kong Branch) from the time when you first
          become aware of such facts or circumstances to the time when you notify a claim arising from those facts and circumstances to the Company,
          subject to the terms and conditions of the policy).
          <br />
          依本保單條款及條件規定，就閣下已知或應當知於保險期前因任何事實或情況所導致之賠償請求，不在本保險單承保範圍之內。(本保單可能提供部分無意不披露的事實及持續延長的保障，但閣下必須向保險公司作出首次索賠之時前持續投保由Allied
          World Assurance Company, Ltd (Hong Kong Branch)世聯保險有限公司（香港分行）簽發的專業責任保單，實際保障範圍受限於本保單之保險條款及及細則。)
        </li>
        <li>
          The policy does not respond to any claim resulting from an act, error or omission occurring or committed by you prior to the retroactive
          date, where a retroactive date is specified in the policy terms which are offered to you.
          <br />
          若本保單條款有追溯日期，本保單不承保任何因閣下於該追溯日期之前作出的作為 、錯誤或不作為所引起的索賠責任。
        </li>
        <li>
          Once the policy period has expired, no notification of claims or facts or circumstances can be made on the policy even though:
          <br />
          保單期滿後，保險公司概不接受閣下向保險公司通知的任何賠償請求、事實或情況負責賠償責任，即使:-
          <ol type="i">
            <li>
              the event giving rise to the claim against you may have occurred during the policy period <br /> 導致賠償請求之事件可能在保單期內發生;
              或{" "}
            </li>
            <li>
              you may have first become aware of the facts or circumstances giving rise to the claim during the policy period.
              <br />
              閣下在保單期內首次知悉可能會產生賠償請求之事實或情況。
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li>
      The questions in this application (this “Application” or your “Application”) relate to facts which Allied World Assurance Company, Ltd (Hong
      Kong Branch), a company incorporated in Bermuda with limited liability (the “Company”) considers material to underwriting this insurance. As
      these questions are not exhaustive, please advise the Company if there is any other material information which could influence the Company’s
      assessment and acceptance of the proposal.
      <br />
      投保書(下稱 “此投保書”)內提出的所有問題對於 Allied World Assurance Company, Ltd (Hong Kong Branch) 世聯保險有限公司(香港分行) (下稱 “保險公司”)
      （於百慕達註冊成立的有限公司之香港分行）
      就有關閣下保單的承保考慮及決定上至關重要。由於這些問題並未盡列在此投保書內，如有其他會影響保險公司風險評估或承保決定的重要事實，
      閣下務必據實向保險公司告知。
    </li>
    <li>
      Prior to entering into a contract of insurance with the Company, you are under a duty to disclose to the Company, every fact you know, or could
      reasonably be expected to know, that may influence the Company’s assessment and acceptance of the risk and the terms of such acceptance. If you
      are uncertain as to whether or not particular information is material, these facts should be disclosed to the Company.
      <br />
      閣下與保險公司訂立保險合約前，有責任向保險公司披露所有已知悉或在合理情況下 預期會知悉可能會影響保險公司的風險評估、承保決定及承保條款之事實。如
      閣下不 確定某項資料是否重要事實，則應向保險公司披露該項資料。
    </li>
    <li>
      Your duty does not require disclosure of any fact:
      <br />
      閣下並無責任向保險公司披露：
      <ol type="a">
        <li>
          That diminishes the risk to be undertaken by the Company;
          <br />
          有關減低保險公司承擔的風險的事實或資料;{" "}
        </li>
        <li>
          That is of common knowledge;
          <br />
          屬眾所周知的事實或資料;{" "}
        </li>
        <li>
          That the Company knows or, in the ordinary course of its business, ought to know; or
          <br />
          保險公司已知，或於其日常業務範圍內所應知的事實或資料; 或
        </li>
        <li>
          {" "}
          As to which compliance with your duty is waived by the Company.
          <br />
          屬已獲保險公司豁免披露責任的事實或資料。{" "}
        </li>
      </ol>
    </li>
    <li>
      You have the same duty to disclose those matters to the Company before you renew, extend, vary or reinstate a contract of insurance.
      <br />
      閣下於辦理保險合約之續約、延長、變更或恢復效力前，對於上述事項，亦對保險公司負有相同之披露責任。
    </li>
    <li>
      All information provided by you in support of your Application for insurance must be correct, as you will be bound by the answers and by the
      information you have provided. If you do not comply with your duty of disclosure or make a misrepresentation, the Company may be entitled to
      reduce its liability under the policy in respect of a claim or may cancel or avoid the policy from its inception. If the non-disclosure or
      misrepresentation is fraudulent, the Company may also have the additional option of avoiding the policy from its inception and retaining the
      premiums paid.
      <br />
      由於 閣下在此投保書內提供的資料對 閣下有約束力，請務必在投保申請時提供正確的 資料。如
      閣下未有履行披露責任或作出任何失實陳述，保險公司有權減免其賠償責任 ，或取消本保單，或由本保單開立起解除本保單。如果當中（即 閣下未有履行披露責
      任或作出任何失實陳述）涉及欺詐成分，保險公司有權選擇自本保單開立起解除本保 單及保留所有已繳付的保費。
    </li>
    <li>
      If your Application was submitted via an insurance intermediary and is accepted, the Company will pay the authorised insurance broker / the
      agent appointed by the Company to arrange the insurance commission during the continuance of the policy, including renewals, for arranging the
      policy.
      <br />
      如此投保書是透過保險中介人提交，而此投保書獲保險公司接納並簽發保單，保險公
      司會於保單有效期內（包括續保期）向負責安排有關保單的保險中介人支付佣金。
    </li>
    <li>
      This product is underwritten by the Hong Kong branch of Allied World Assurance Company, Ltd (the “Company”) which is regulated by the Insurance
      Authority.
      <br />
      本計劃乃由Allied World Assurance Company, Ltd世聯保險有限公司之香港分行承保 ，而該分行受保險業監管局監管。
    </li>
    <li>
      This product is for Hong Kong distribution only. It is not an offer to sell, a solicitation to buy nor provision of any insurance product
      outside Hong Kong. The Company does not offer or sell any insurance product in any jurisdictions outside Hong Kong in which such offering or
      sale of the insurance product is illegal under the laws of such jurisdictions.
      <br />
      本計劃僅擬在香港特別行政區境內銷售，並不能詮釋為保險公司在香港境外出售、遊
      說購買或提供任何保險產品。如在香港境外之任何司法管轄區的法律下提供或出售任
      何保險產品屬違法，保險公司不會在該香港境外之司法管轄區提供或出售保險產品。
    </li>
    <li>
      This Policy shall be governed by and construed in accordance with the laws of Hong Kong and any dispute or difference that arises under this
      Policy shall be settled in accordance with the laws of Hong Kong.
      <br />
      本保單受香港法律管轄及約束，並根據該法律解釋。凡因本保單所引起的或與之相關 的任何爭議、糾紛或分歧，均應按照香港法律解決。
    </li>
    <li>
      IA Levy imposed by the Insurance Authority applies to this Policy at the applicable rate. You can find further information on the IA Levy{" "}
      <a href={levyAttachment} rel="noreferrer" target="_blank">
        here
      </a>
      .<br />
      保險業監管局將按照適用的徵費率向 閣下收取的保費徵費適用於本保單。有關保費徵 費詳情，可瀏覽 網頁。
    </li>
  </ol>
);

export default ImportantNoticesTerms;
